// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-list-item-group .v-list-item--active{color:inherit}", "",{"version":3,"sources":["/builds/simplenexus-engineering/simplenexus.com/node_modules/vuetify2/src/components/VList/VListItemGroup.sass"],"names":[],"mappings":"AAIE,wCACE,aAAA","file":"VListItemGroup.sass","sourcesContent":["@import '~/assets/css/snui/variables.scss'\n@import './_variables.scss'\n\n.v-list-item-group\n  .v-list-item--active\n    color: inherit\n"]}]);
// Exports
module.exports = exports;
